module.exports = __webpack_public_path__ + "img/en.f4cc0b5e.svg";